import axios from 'axios'
import router from '../router/index.js'
import { MessageBox, Message } from 'element-ui'

// 创建axios 实例
const service = axios.create({
    // baseURL: '/api',  //请求根路径
    baseURL: process.env.NODE_ENV === 'development' ? 
        '/api'
        :
        window.location.origin,  
    timeout: 10000, //超时时间，10秒
    loading: true,
})
//请求拦截器
service.interceptors.request.use(
    config => {
        if (config.method === "get") {
            config.data = {
                unused: 0
            }; // 这个是关键点，加入这行就可以解决get请求添加不上Content-Type
        }
        
        // 请求数据是字符串去掉前后空格
        Object.keys(config.data || {}).forEach(key => {
            if(typeof config.data[key] === 'string') {
                config.data[key] = config.data[key].trim();
            }
        })
        Object.keys(config.params || {}).forEach(key => {
            if(typeof config.params[key] === 'string') {
                config.params[key] = config.params[key].trim();
            }
        })
        // console.log('config', config.data, config.params);

        // 配置请求头
        if (config.url === "/setweb/index") {
            config.data = JSON.stringify(config.data);
            config.headers['Content-Type'] = 'multipart/form-data';
        }
        //else {
        //     config.headers["Content-type"] = "application/json;charset=UTF-8";
        // }
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

//响应拦截器
service.interceptors.response.use(response => {
    // console.log(response);
    // 不做处理，请求成功直接返回
    // return response

    // 验证码不走下面流程
    // if(response.config.url == '/captcha') {
    if(response.config.url == '/share/user/captcha') {
        return Promise.resolve(response)
    }

    // 做处理，如果未登录强制跳到登录页面
    if (response.data.state === 0) {
        return Promise.resolve(response)
    } else {
        if (response.data.state == '4001') {
            window.sessionStorage.removeItem('yxLoginPhone');
            setTimeout(() => {
                router.push('/login');
            }, 1500)
        } else {
            Message({
                message: response.data.msg || '请求失败',
                type: 'error',
                duration: 5 * 1000,
                customClass: 'z-index-9999'
              })
            return Promise.reject(response)
        }
    }
}, error => {
    // console.log(error, '+++++++'); //打印错误
    Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000,
        customClass: 'z-index-9999'
      })
    // 请求超时 ， 跳到无网络页面
    // if (error.message.includes('timeout')) {
    //     Toast("请求超时，请检查网络后重试")
    //     router.push('/no_network');
    // }
    return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/config/index.js